import { IConsultationOutcome } from '../../hooks/promises/getConsultationOutcomes';
import { AttendanceStatus } from './enums';

export function getAttendanceStatus(
  didNotAttend: boolean,
  lateCancellation: boolean
): AttendanceStatus {
  if (didNotAttend && lateCancellation) {
    return AttendanceStatus.DidNotAttendLateCancellation;
  }
  if (didNotAttend) {
    return AttendanceStatus.DidNotAttend;
  }
  if (lateCancellation) {
    return AttendanceStatus.LateCancellation;
  }
  return AttendanceStatus.Attended;
}

export function filterOutcomes(
  userInput: string,
  consultationOutcomes: IConsultationOutcome[]
) {
  return consultationOutcomes.filter((outcome) =>
    outcome.consultationOutcomeDescriptionShort
      .toLowerCase()
      .includes(userInput.toLowerCase())
  );
}

export const consultationTypeRequiresFollowUp = (id?: number) => {
  if (!id) return false;
  const firstFollowUp = 2;
  const secondFollowUp = 3;
  const thirdFollowUp = 4;

  return [firstFollowUp, secondFollowUp, thirdFollowUp].includes(id);
};
